import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Snackbar } from "@mui/material";
import { useSensorImageNotice } from "./useSensorImageNotice";

export default function SensorImageSnackbar(): React.ReactNode {
  const { t } = useTranslation();
  const noImagesForDate = useSensorImageNotice(
    (state) => state.noImagesForDate,
  );
  const noRawSensorImages = useSensorImageNotice(
    (state) => state.noRawSensorImages,
  );
  const clearNotices = useSensorImageNotice((state) => state.clearNotices);
  const lastMessage = useRef("");

  const message = noRawSensorImages
    ? t("message.No raw sensor images available for driving day")
    : noImagesForDate
      ? t("message.no_treescout_image")
      : "";

  if (message) {
    lastMessage.current = message;
  }

  return (
    <Snackbar
      open={Boolean(message)}
      autoHideDuration={6000}
      onClose={clearNotices}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        variant="filled"
        severity="warning"
        onClose={clearNotices}
        sx={{ width: "100%" }}
      >
        {lastMessage.current}
      </Alert>
    </Snackbar>
  );
}
